import { descargarXlsx } from '../../lib/xlsx';

// CSV para Excel en espanol: separador ";" y BOM para que respete las tildes.
export function descargarCsv(nombre: string, filas: (string | number)[][]) {
  const csv = filas.map((f) => f.map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`).join(';')).join('\r\n');
  const url = URL.createObjectURL(new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Lo mismo en Excel (.xlsx, D95): los decimales que llegan como texto ("1.50") pasan a numero para poder sumarlos.
export function descargarExcel(nombre: string, filas: (string | number)[][]) {
  const base = nombre.replace(/\.(csv|xlsx)$/i, '');
  const hoja = base.replace(/-\d{4}-\d{2}(-\d{2})?$/, '').replace(/-/g, ' ');
  descargarXlsx(base, [{ nombre: hoja.charAt(0).toUpperCase() + hoja.slice(1), filas: filas.map((f, i) => (i ? f.map((v) => (typeof v === 'string' && /^-?\d{1,9}\.\d+$/.test(v) ? Number(v) : v)) : f)) }]);
}
